import { defineComponent as s, createBlock as a, openBlock as i, unref as o, withCtx as m, createElementVNode as t, createCommentVNode as l, createVNode as n, createElementBlock as d, toDisplayString as r } from "vue";
import { RevButtonCard as c } from "@ds/components/ButtonCard";
import { RevIllustration as h } from "@ds/components/Illustration";
import { RevIllustrationSource as g } from "@ds/components/IllustrationSource";
const u = { class: "flex h-full flex-col items-center justify-start p-16 md:p-24 md:pt-32" }, f = { class: "mx-auto mb-32 flex max-h-full min-h-0 w-full max-w-320 justify-center sm:mb-12 md:mb-24" }, p = { class: "self-stretch text-center md:text-left" }, k = { class: "text-static-default-hi body-1" }, b = {
  key: 0,
  class: "text-static-default-low body-2 hidden md:mt-4 md:block"
}, R = /* @__PURE__ */ s({
  name: "RevCategoryCard",
  __name: "CategoryCard",
  props: {
    title: {},
    description: {},
    image: {},
    link: {},
    tracking: {}
  },
  setup(w) {
    return (e, y) => (i(), a(o(c), {
      class: "inline-block min-h-[13rem] w-full sm:min-h-[13.5rem]",
      to: e.link,
      tracking: e.tracking
    }, {
      default: m(() => [
        t("div", u, [
          t("picture", f, [
            e.image.srcMobile ? (i(), a(o(g), {
              key: 0,
              height: e.image.heightMobile || e.image.height,
              media: "(max-width: 480px)",
              src: e.image.srcMobile,
              width: e.image.widthMobile || e.image.width
            }, null, 8, ["height", "src", "width"])) : l("", !0),
            n(o(h), {
              alt: e.image.alt,
              class: "block object-contain",
              height: e.image.height,
              src: e.image.src,
              width: e.image.width
            }, null, 8, ["alt", "height", "src", "width"])
          ]),
          t("div", p, [
            t("h2", k, r(e.title), 1),
            e.description ? (i(), d("span", b, r(e.description), 1)) : l("", !0)
          ])
        ])
      ]),
      _: 1
    }, 8, ["to", "tracking"]));
  }
});
export {
  R as default
};
